<ng-template #chatInputTemplate>
  <button
    type="button"
    class="info-modal-close"
    aria-label="Close"
    (click)="modalRef.close()"
  >
    <svg-icon
      class="icon-close"
      [src]="'../../../assets/images/icons/close.svg'"
    ></svg-icon>
  </button>
  <div class="modal-form-container">
    <form [formGroup]="formGroup" class="message-form">
      <app-textarea
        id="user-message-input-area"
        controlName="message"
        placeholder="userMessages.message"
      ></app-textarea>
      <button class="btn btn-danger" (click)="submit()">
        {{ prefix + "send" | msg | async }}
      </button>
    </form>
  </div>
</ng-template>
